import { gql } from '@apollo/client';

export default gql`
  mutation removeStudentsMutation($where: StudentsWhereInput!) {
    removeStudents(where: $where) {
      count
    }
  }
`;
